import { useState, useCallback ,useEffect} from 'react';
import jwtAxios from 'axios';
import Cookies from 'js-cookie';

const useApi = ({ alert, setIsLoading, onLogout, onError }) => {
  const [axiosInstance,setAxiosInstance] = useState(() => {
    return jwtAxios.create({
      baseURL: process.env.REACT_APP_BACKEND_URL, 
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'multipart/form-data'
      },
    });
  });
  
  const setCookie = (name, value, days) => {
    const expirationDate = new Date();
    expirationDate.setDate(expirationDate.getDate() + days);  
    const cookieValue = `${encodeURIComponent(name)}=${encodeURIComponent(value)};expires=${expirationDate.toUTCString()};path=/;SameSite=Lax;`;
    document.cookie = cookieValue;
  };
  const setAuthToken = useCallback((token,expries_in) => {
    setAxiosInstance((prevInstance) => {
      const updatedInstance = prevInstance;
      updatedInstance.defaults.headers.common['Authorization'] = `Bearer ${token}`;
      localStorage.setItem('token', token);
      setCookie("token",token,expries_in);
      
      return updatedInstance;
    });
  }, []);


  const api = useCallback(
    (url, config = {}) => {
      return axiosInstance({
        method: config.method,
        url,
        data: config.body,
        ...config,
      })
        .then((response) => {
          setIsLoading(false);
          // if(config.method){
          //   alert({
          //     type: "success",
          //     title: response.data.messages[0].title,
          //     detail: response.data.messages[0].description,
          //     life: 4000  
          //   }) 
          // }
          return { ok: true, body: response.data };
        })
        .catch((error) => {
          setIsLoading(false);
          const status = error.response?.status;
          const errorData = error.response?.data;

          if (status === 400 && errorData?.messages && Array.isArray(errorData.messages)) {
            errorData.messages.forEach((message) => {
              alert({
                type: message.level,
                title: message.title || "Atención",
                detail: message.description,
                life: 4000  
              });
            });
          }
          else if (status >= 500) {
            console.error("Error crítico del servidor:", error);
            alert({
              type: "error",
              title: "Servidor no disponible",
              detail: "Estamos experimentando inconvenientes técnicos. Por favor, intentá nuevamente en unos minutos.",
              life: 8000  
            });
          }
          else if(status !== 401) {
            console.error("Error inesperado en la API:", error);
            alert({
              type: "error",
              title: "Error!",
              detail: "Algo no salió como esperabamos, por favor intentá nuevamente.",
              life: 8000  
            })  
          }
          if (jwtAxios.isCancel(error)) {
            // Manejar cancelaciones si es necesario
          } else if (error.response) { 
            onError(error.response.data);
          } else if (error.request) {
            console.error("No se recibió respuesta del servidor (Posible caída de red o CORS):", error.request);
            onError('No se recibió respuesta del servidor');
          } else {
            onError('Error durante la configuración de la solicitud');
          }

          return { ok: false, body: error.response?.data || null };
        });
    },
    [alert, axiosInstance, setIsLoading, onError]
  );
  useEffect(() => {
    const token = Cookies.get('token');
    if (token) {
      setAuthToken(token);
    }
  }, [setAuthToken]);

  return {api,setAuthToken};
};

export default useApi;